import React, { Component } from 'react';
import CodeGroupsSegment from 'components/segments/CodeGroupsSegment';
import { Grid } from 'semantic-ui-react';
import { BaseEntityCodeDto, CodeDto } from 'ts-types/api.types';

interface Props {
  patientCodes: Array<BaseEntityCodeDto>,
  addToPatientCodes: (code: CodeDto) => void,
  addAllToPatientCodes: (codes: Array<CodeDto>) => void
  removeFromPatientCodes: (code: BaseEntityCodeDto) => void
  removeAllFromPatientCodes: () => void
}

class GeneratedCodesPane extends Component<Props> {

  render(): React.ReactNode {

    const {patientCodes, addToPatientCodes, addAllToPatientCodes, removeFromPatientCodes, removeAllFromPatientCodes} = this.props;

    return (
        <React.Fragment>
          <Grid.Row>
            <CodeGroupsSegment
                selectedCodes={patientCodes}
                moveToSelected={addToPatientCodes}
                moveAllToSelected={addAllToPatientCodes}
                removeFromSelected={removeFromPatientCodes}
                removeAllFromSelected={removeAllFromPatientCodes}
            />
          </Grid.Row>
        </React.Fragment>
    );
  }
}

export default GeneratedCodesPane;
